import Utility from "../../../shared/utility.js";
import EncryptUtility from "../../utility/js/encrypt-utility.js";
import AddFavourite from "../../utility/js/addFav.js";
import breadcrumbComp from "../../common/breadcrumb-comp";
import documentService from "../js/document-upload-service.js";
export default {
  data() {
    return {
      refresh: true,
      backSlash: true,
      actionList: [],
      mainPage: "",
      subPage: "",
      pageUrl: "",
      favouriteList: [],
      showAdd: false,
      userId: EncryptUtility.localStorageDecrypt("userID"),
      searchFilter: "",
      accountItems: [],
      showAccount: true,
      documentOriginItems: [],
      showDocumentOrigin: false,
      documentTypeItems: [],
      showDocumentType: false,
      documentStatusItems: [],
      showDocumentStatus: false,
      documentDifficultyItems: [],
      showDocumentDifficulty: false,
      newBtnName: "Add New Account",
      editBtnName: "Edit Account",
      totalRecords: 0,
      documentEditDialog: false,
      editDocumentData: [],
      editAccountName: "",
      editAccountManager: "",
      editBackupManager: "",
      editShortDescription: "",
      editOriginType: "",
      editType: "",
      editDescription: "",
      editStatus: "",
      editDifficulty: "",
      documentAddDialog: false,
      addAccountName: "",
      addAccountManager: "",
      addBackupManager: "",
      addShortDescription: "",
      addOriginType: "",
      addType: "",
      addDescription: "",
      addStatus: "",
      addDifficulty: "",
      deleteDocumentData: [],
      deleteDocumentDialog: false,
      masterName: "",
      managerData: [],
      page: 1,
      pageCount: 0,
      exportDisable: true,
      max100Rule: [(v) => !!v || "Field is required", (v) => (v || "").length <= 100 || "Max Length must be 100 characters or less"],
      max50Rule: [(v) => !!v || "Field is required", (v) => (v || "").length <= 50 || "Max Length must be 50 characters or less"],
      max252Rule: [(v) => !!v || "Field is required", (v) => (v || "").length <= 252 || "Max Length must be 252 characters or less"],
      required: [(v) => !!v || "Field is required"],
      headersAccount: [
        { text: "Account Name", align: "start", value: "account_name", class: "primary customwhite--text" },
        { text: "Account Manager", value: "manager_name", class: "primary customwhite--text" },
        { text: "Account Back up Manager", value: "backup_manager_name", class: "primary customwhite--text" },
        { text: "Short Description", value: "short_description", class: "primary customwhite--text" },
        { text: "Actions", value: "actions", class: "primary customwhite--text" },
      ],
      headersDocumentOrigin: [
        { text: "Origin Type", align: "start", value: "origin_name", class: "primary customwhite--text" },
        { text: "Actions", value: "actions", class: "primary customwhite--text" },
      ],
      headersDocumentType: [
        { text: "Type", align: "start", value: "type_name", class: "primary customwhite--text" },
        { text: "Description", value: "description", class: "primary customwhite--text" },
        { text: "Actions", value: "actions", class: "primary customwhite--text" },
      ],
      headersDocumentStatus: [
        { text: "Status", align: "start", value: "status_name", class: "primary customwhite--text" },
        { text: "Actions", value: "actions", class: "primary customwhite--text" },
      ],
      headersDocumentDifficulty: [
        { text: "Difficulty", align: "start", value: "difficulty_name", class: "primary customwhite--text" },
        { text: "Actions", value: "actions", class: "primary customwhite--text" },
      ],
      documentMasters: [
        { id: 1, name: "Account" },
        { id: 2, name: "Document Origin" },
        { id: 3, name: "Document Type" },
        { id: 4, name: "Document Status" },
        { id: 5, name: "Difficulty" },
      ],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.loadDropdowns();
    this.documentMasterClick("Account");
  },
  methods: {
    //Reset Function
    resetFunction() {
      this.searchFilter = "";
      this.accountItems = [];
      this.showAccount = true;
      this.documentOriginItems = [];
      this.showDocumentOrigin = false;
      this.documentTypeItems = [];
      this.showDocumentType = false;
      this.documentStatusItems = [];
      this.showDocumentStatus = false;
      this.documentDifficultyItems = [];
      this.showDocumentDifficulty = false;
      this.newBtnName = "Add New Account";
      this.editBtnName = "Edit Account";
      this.totalRecords = 0;
      this.documentEditDialog = false;
      this.editDocumentData = [];
      this.editAccountName = "";
      this.editAccountManager = "";
      this.editBackupManager = "";
      this.editShortDescription = "";
      this.editOriginType = "";
      this.editType = "";
      this.editDescription = "";
      this.editStatus = "";
      this.editDifficulty = "";
      this.documentAddDialog = false;
      this.addAccountName = "";
      this.addAccountManager = "";
      this.addBackupManager = "";
      this.addShortDescription = "";
      this.addOriginType = "";
      this.addType = "";
      this.addDescription = "";
      this.addStatus = "";
      this.addDifficulty = "";
      this.deleteDocumentData = [];
      this.deleteDocumentDialog = false;
      this.masterName = "";
      this.managerData = [];
      this.page = 1;
      this.pageCount = 0;
      this.exportDisable = true;
      this.loadDropdowns();
      this.documentMasterClick("Account");
    },
    //Document button click
    async documentMasterClick(name) {
      this.masterName = name;
      if (name == "Account") {
        let obj = {
          pass: 1,
          user_id: parseInt(this.userId),
          account_id: 1,
          account_name: "",
          manager_id: 1,
          backup_manager_id: 1,
          active: true,
          short_description: "",
        };
        let data = await documentService.getDocumentAccount("post", obj, false);
        this.searchFilter = "";
        this.accountItems = Array.isArray(data) ? data : [];
        this.showAccount = true;
        this.documentOriginItems = [];
        this.showDocumentOrigin = false;
        this.documentTypeItems = [];
        this.showDocumentType = false;
        this.documentStatusItems = [];
        this.showDocumentStatus = false;
        this.documentDifficultyItems = [];
        this.showDocumentDifficulty = false;
        this.trainingReportItems = [];
        this.searchFilterTrainingRecords = "";
        this.newBtnName = "Add New Account";
        this.editBtnName = "Edit Account";
        this.totalRecords = Array.isArray(data) ? data.length : 0;
        let dropObj = {
          pass: 6,
          user_id: parseInt(this.userId),
          account_id: 1,
          account_name: "",
          manager_id: 1,
          backup_manager_id: 1,
          active: true,
          short_description: "",
        };
        let dropData = await documentService.getDocumentAccount("post", dropObj, false);
        if (dropData.message !== "NA") {
          this.managerData = [];
          this.managerData = dropData;
        }
      }
      if (name == "Document Origin") {
        let obj = {
          pass: 1,
          user_id: parseInt(this.userId),
          origin_id: 1,
          origin_name: "",
        };
        let data = await documentService.getDocumentOrigin("post", obj, false);
        this.searchFilter = "";
        this.accountItems = [];
        this.showAccount = false;
        this.documentOriginItems = Array.isArray(data) ? data : [];
        this.showDocumentOrigin = true;
        this.documentTypeItems = [];
        this.showDocumentType = false;
        this.documentStatusItems = [];
        this.showDocumentStatus = false;
        this.documentDifficultyItems = [];
        this.showDocumentDifficulty = false;
        this.trainingReportItems = [];
        this.searchFilterTrainingRecords = "";
        this.newBtnName = "Add New Origin";
        this.editBtnName = "Edit Origin";
        this.totalRecords = Array.isArray(data) ? data.length : 0;
      }
      if (name == "Document Type") {
        let obj = {
          pass: 1,
          user_id: parseInt(this.userId),
          type_id: 0,
          type_name: "",
        };
        let data = await documentService.getDocumentType("post", obj, false);
        this.searchFilter = "";
        this.accountItems = [];
        this.showAccount = false;
        this.documentOriginItems = [];
        this.showDocumentOrigin = false;
        this.documentTypeItems = Array.isArray(data) ? data : [];
        this.showDocumentType = true;
        this.documentStatusItems = [];
        this.showDocumentStatus = false;
        this.documentDifficultyItems = [];
        this.showDocumentDifficulty = false;
        this.trainingReportItems = [];
        this.searchFilterTrainingRecords = "";
        this.newBtnName = "Add New Type";
        this.editBtnName = "Edit Type";
        this.totalRecords = Array.isArray(data) ? data.length : 0;
      }
      if (name == "Document Status") {
        let obj = {
          pass: 1,
          user_id: parseInt(this.userId),
          status_id: 0,
          status_name: "",
        };
        let data = await documentService.getDocumentStatus("post", obj, false);
        this.searchFilter = "";
        this.accountItems = [];
        this.showAccount = false;
        this.documentOriginItems = [];
        this.showDocumentOrigin = false;
        this.documentTypeItems = [];
        this.showDocumentType = false;
        this.documentStatusItems = Array.isArray(data) ? data : [];
        this.showDocumentStatus = true;
        this.documentDifficultyItems = [];
        this.showDocumentDifficulty = false;
        this.trainingReportItems = [];
        this.searchFilterTrainingRecords = "";
        this.newBtnName = "Add New Status";
        this.editBtnName = "Edit Status";
        this.totalRecords = Array.isArray(data) ? data.length : 0;
      }
      if (name == "Difficulty") {
        let obj = {
          pass: 1,
          user_id: parseInt(this.userId),
          difficulty_id: 0,
          difficulty_name: "",
        };
        let data = await documentService.getDocumentDifficulty("post", obj, false);
        this.searchFilter = "";
        this.accountItems = [];
        this.showAccount = false;
        this.documentOriginItems = [];
        this.showDocumentOrigin = false;
        this.documentTypeItems = [];
        this.showDocumentType = false;
        this.documentStatusItems = [];
        this.showDocumentStatus = false;
        this.documentDifficultyItems = Array.isArray(data) ? data : [];
        this.showDocumentDifficulty = true;
        this.trainingReportItems = [];
        this.searchFilterTrainingRecords = "";
        this.newBtnName = "Add New Difficulty Level";
        this.editBtnName = "Edit Difficulty Level";
        this.totalRecords = data.length;
      }
    },
    async loadDropdowns() {
      let masterObj = {
        pass: 0,
        user_id: parseInt(this.userId),
      };
      let masterData = await documentService.documentLoadMasters("post", masterObj, false);
      if (masterData.message !== "NA") {
        this.accountNameList = masterData.document_account;
        this.documentTypeList = masterData.document_type;
        this.documentStatusList = masterData.document_status;
        this.personnelList = masterData.applicable_personnel;
      }
    },
    //Edit Details click
    async editDetails(item) {
      this.editDocumentData = [];
      if (this.editBtnName == "Edit Account") {
        let obj = {
          pass: 2,
          user_id: parseInt(this.userId),
          account_id: item.account_id,
          account_name: "",
          manager_id: 1,
          backup_manager_id: 1,
          active: true,
          short_description: "",
        };
        let data = await documentService.getDocumentAccount("post", obj, false);
        if (data.message !== "NA") {
          this.editDocumentData = data;
          this.editAccountName = this.editDocumentData[0]?.account_name;
          this.editAccountManager = this.editDocumentData[0]?.manager_id;
          this.editBackupManager = this.editDocumentData[0]?.backup_manager_id;
          this.editShortDescription = this.editDocumentData[0]?.short_description;
        }
      } else if (this.editBtnName == "Edit Origin") {
        let obj = {
          pass: 2,
          user_id: parseInt(this.userId),
          origin_id: item.origin_id,
          origin_name: "string",
        };
        let data = await documentService.getDocumentOrigin("post", obj, false);
        if (data.message !== "NA") {
          this.editDocumentData = data;
          this.editOriginType = this.editDocumentData[0]?.origin_name;
        }
      } else if (this.editBtnName == "Edit Type") {
        let obj = {
          pass: 2,
          user_id: parseInt(this.userId),
          type_id: item.type_id,
          type_name: "",
        };
        let data = await documentService.getDocumentType("post", obj, false);
        if (data.message !== "NA") {
          this.editDocumentData = data;
          this.editType = this.editDocumentData[0]?.type_name;
          this.editDescription = this.editDocumentData[0]?.description;
        }
      } else if (this.editBtnName == "Edit Status") {
        let obj = {
          pass: 2,
          user_id: parseInt(this.userId),
          status_id: item.status_id,
          status_name: "",
        };
        let data = await documentService.getDocumentStatus("post", obj, false);
        if (data.message !== "NA") {
          this.editDocumentData = data;
          this.editStatus = this.editDocumentData[0]?.status_name;
        }
      } else if (this.editBtnName == "Edit Difficulty Level") {
        let obj = {
          pass: 2,
          user_id: parseInt(this.userId),
          difficulty_id: item.difficulty_id,
          difficulty_name: "",
        };
        let data = await documentService.getDocumentDifficulty("post", obj, false);
        if (data.message !== "NA") {
          this.editDocumentData = data;
          this.editDifficulty = this.editDocumentData[0]?.difficulty_name;
        }
      }
      this.documentEditDialog = true;
    },
    //Delete Details click
    async deleteDetails(item) {
      this.deleteDocumentData = [];
      this.deleteDocumentData = item;
      this.deleteDocumentDialog = true;
    },
    //On CLose of confirmation popup
    onClose() {
      this.deleteDocumentData = [];
      this.deleteDocumentDialog = false;
      this.documentMasterClick(this.masterName);
    },
    //Ok click on confirmation popup
    async deleteDocumentDetails() {
      if (this.editBtnName == "Edit Account") {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        let obj = {
          pass: 5,
          user_id: parseInt(this.userId),
          account_id: this.deleteDocumentData.account_id,
          account_name: "",
          manager_id: 1,
          backup_manager_id: 1,
          active: true,
          short_description: "",
        };
        this.axios
          .post("/du/get_document_account", obj)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.body.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.onClose();
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      } else if (this.editBtnName == "Edit Origin") {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        let obj = {
          pass: 5,
          user_id: parseInt(this.userId),
          origin_id: this.deleteDocumentData.origin_id,
          origin_name: "string",
        };
        this.axios
          .post("/du/get_document_origin", obj)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.body.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.onClose();
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      } else if (this.editBtnName == "Edit Type") {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        let obj = {
          pass: 5,
          user_id: parseInt(this.userId),
          type_id: this.deleteDocumentData.type_id,
          type_name: "",
        };
        this.axios
          .post("/du/get_document_type", obj)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.body.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.onClose();
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      } else if (this.editBtnName == "Edit Status") {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        let obj = {
          pass: 5,
          user_id: parseInt(this.userId),
          status_id: this.deleteDocumentData.status_id,
          status_name: "",
        };
        this.axios
          .post("/du/get_document_status", obj)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.body.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.onClose();
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      } else if (this.editBtnName == "Edit Difficulty Level") {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        let obj = {
          pass: 5,
          user_id: parseInt(this.userId),
          difficulty_id: this.deleteDocumentData.difficulty_id,
          difficulty_name: "",
        };
        this.axios
          .post("/du/get_document_difficulty", obj)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let Alert = {
                type: "success",
                isShow: true,
                message: response.data.body.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.onClose();
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      }
    },
    //Edit Cancel and close
    editCancel() {
      this.editDocumentData = [];
      this.documentEditDialog = false;
      this.editAccountName = "";
      this.editAccountManager = "";
      this.editBackupManager = "";
      this.editShortDescription = "";
      this.editOriginType = "";
      this.editType = "";
      this.editDescription = "";
      this.editStatus = "";
      this.editDifficulty = "";
      this.documentMasterClick(this.masterName);
    },
    //Add Cancel and close
    addCancel() {
      this.documentAddDialog = false;
      this.addAccountName = "";
      this.addAccountManager = "";
      this.addBackupManager = "";
      this.addShortDescription = "";
      this.addOriginType = "";
      this.addType = "";
      this.addDescription = "";
      this.addStatus = "";
      this.addDifficulty = "";
      this.documentMasterClick(this.masterName);
    },
    //New Button clicked
    newBtnClicked() {
      this.documentAddDialog = true;
    },
    //Navigate to document account add page
    goToDocumentAccountAdd() {
      this.$router.push("/document-account-add");
    },
    //Edit Details submit
    editDetailsSubmit() {
      if (this.$refs.editDocumentForm.validate()) {
        if (this.editBtnName == "Edit Account") {
          let LoaderDialog = {
            visible: true,
            title: "Please Wait...",
          };
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let obj = {
            pass: 4,
            user_id: parseInt(this.userId),
            account_id: this.editDocumentData[0]?.account_id,
            account_name: this.editAccountName.toUpperCase(),
            manager_id: parseInt(this.editAccountManager),
            backup_manager_id: parseInt(this.editBackupManager),
            active: true,
            short_description: this.editShortDescription,
          };
          this.axios
            .post("/du/get_document_account", obj)
            .then((response) => {
              if (response.status == 200 || response.status == 204) {
                let Alert = {
                  type: "success",
                  isShow: true,
                  message: response.data.body.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
                this.editCancel();
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              } else {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                let Alert = {
                  type: "error",
                  isShow: true,
                  message: response.data.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            })
            .catch((error) => {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: Utility.apiError(error),
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.errorMessage = error.message;
            });
        } else if (this.editBtnName == "Edit Origin") {
          let LoaderDialog = {
            visible: true,
            title: "Please Wait...",
          };
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let obj = {
            pass: 4,
            user_id: parseInt(this.userId),
            origin_id: this.editDocumentData[0]?.origin_id,
            origin_name: this.editOriginType.toUpperCase(),
          };
          this.axios
            .post("/du/get_document_origin", obj)
            .then((response) => {
              if (response.status == 200 || response.status == 204) {
                let Alert = {
                  type: "success",
                  isShow: true,
                  message: response.data.body.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
                this.editCancel();
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              } else {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                let Alert = {
                  type: "error",
                  isShow: true,
                  message: response.data.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            })
            .catch((error) => {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: Utility.apiError(error),
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.errorMessage = error.message;
            });
        } else if (this.editBtnName == "Edit Type") {
          let LoaderDialog = {
            visible: true,
            title: "Please Wait...",
          };
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let obj = {
            pass: 4,
            user_id: parseInt(this.userId),
            type_id: this.editDocumentData[0]?.type_id,
            type_name: this.editType.toUpperCase(),
            description: this.editDescription,
          };
          this.axios
            .post("/du/get_document_type", obj)
            .then((response) => {
              if (response.status == 200 || response.status == 204) {
                let Alert = {
                  type: "success",
                  isShow: true,
                  message: response.data.body.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
                this.editCancel();
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              } else {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                let Alert = {
                  type: "error",
                  isShow: true,
                  message: response.data.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            })
            .catch((error) => {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: Utility.apiError(error),
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.errorMessage = error.message;
            });
        } else if (this.editBtnName == "Edit Status") {
          let LoaderDialog = {
            visible: true,
            title: "Please Wait...",
          };
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let obj = {
            pass: 4,
            user_id: parseInt(this.userId),
            status_id: this.editDocumentData[0]?.status_id,
            status_name: this.editStatus.toUpperCase(),
          };
          this.axios
            .post("/du/get_document_status", obj)
            .then((response) => {
              if (response.status == 200 || response.status == 204) {
                let Alert = {
                  type: "success",
                  isShow: true,
                  message: response.data.body.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
                this.editCancel();
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              } else {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                let Alert = {
                  type: "error",
                  isShow: true,
                  message: response.data.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            })
            .catch((error) => {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: Utility.apiError(error),
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.errorMessage = error.message;
            });
        } else if (this.editBtnName == "Edit Difficulty Level") {
          let LoaderDialog = {
            visible: true,
            title: "Please Wait...",
          };
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let obj = {
            pass: 4,
            user_id: parseInt(this.userId),
            difficulty_id: this.editDocumentData[0]?.difficulty_id,
            difficulty_name: this.editDifficulty.toUpperCase(),
          };
          this.axios
            .post("/du/get_document_difficulty", obj)
            .then((response) => {
              if (response.status == 200 || response.status == 204) {
                let Alert = {
                  type: "success",
                  isShow: true,
                  message: response.data.body.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
                this.editCancel();
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              } else {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                let Alert = {
                  type: "error",
                  isShow: true,
                  message: response.data.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            })
            .catch((error) => {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: Utility.apiError(error),
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.errorMessage = error.message;
            });
        }
      }
    },
    //Add Details Submit
    async addDetailsSubmit() {
      if (this.$refs.addDocumentForm.validate()) {
        if (this.newBtnName == "Add New Account") {
          let LoaderDialog = {
            visible: true,
            title: "Please Wait...",
          };
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let obj = {
            pass: 3,
            user_id: parseInt(this.userId),
            account_id: 0,
            account_name: this.addAccountName.toUpperCase(),
            manager_id: parseInt(this.addAccountManager),
            backup_manager_id: parseInt(this.addBackupManager),
            active: true,
            short_description: this.addShortDescription,
          };
          this.axios
            .post("/du/get_document_account", obj)
            .then((response) => {
              if (response.status == 200 || response.status == 204) {
                let Alert = {
                  type: "success",
                  isShow: true,
                  message: response.data.body.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
                this.addCancel();
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              } else {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                let Alert = {
                  type: "error",
                  isShow: true,
                  message: response.data.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            })
            .catch((error) => {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: Utility.apiError(error),
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.errorMessage = error.message;
            });
        } else if (this.newBtnName == "Add New Origin") {
          let LoaderDialog = {
            visible: true,
            title: "Please Wait...",
          };
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let obj = {
            pass: 3,
            user_id: parseInt(this.userId),
            origin_id: 0,
            origin_name: this.addOriginType.toUpperCase(),
          };
          this.axios
            .post("/du/get_document_origin", obj)
            .then((response) => {
              if (response.status == 200 || response.status == 204) {
                let Alert = {
                  type: "success",
                  isShow: true,
                  message: response.data.body.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
                this.addCancel();
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              } else {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                let Alert = {
                  type: "error",
                  isShow: true,
                  message: response.data.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            })
            .catch((error) => {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: Utility.apiError(error),
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.errorMessage = error.message;
            });
        } else if (this.newBtnName == "Add New Type") {
          let LoaderDialog = {
            visible: true,
            title: "Please Wait...",
          };
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let obj = {
            pass: 3,
            user_id: parseInt(this.userId),
            type_id: 0,
            type_name: this.addType.toUpperCase(),
            description: this.addDescription,
          };
          this.axios
            .post("/du/get_document_type", obj)
            .then((response) => {
              if (response.status == 200 || response.status == 204) {
                let Alert = {
                  type: "success",
                  isShow: true,
                  message: response.data.body.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
                this.addCancel();
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              } else {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                let Alert = {
                  type: "error",
                  isShow: true,
                  message: response.data.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            })
            .catch((error) => {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: Utility.apiError(error),
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.errorMessage = error.message;
            });
        } else if (this.newBtnName == "Add New Status") {
          let LoaderDialog = {
            visible: true,
            title: "Please Wait...",
          };
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let obj = {
            pass: 3,
            user_id: parseInt(this.userId),
            status_id: 0,
            status_name: this.addStatus.toUpperCase(),
          };
          this.axios
            .post("/du/get_document_status", obj)
            .then((response) => {
              if (response.status == 200 || response.status == 204) {
                let Alert = {
                  type: "success",
                  isShow: true,
                  message: response.data.body.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
                this.addCancel();
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              } else {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                let Alert = {
                  type: "error",
                  isShow: true,
                  message: response.data.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            })
            .catch((error) => {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: Utility.apiError(error),
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.errorMessage = error.message;
            });
        } else if (this.newBtnName == "Add New Difficulty Level") {
          let LoaderDialog = {
            visible: true,
            title: "Please Wait...",
          };
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let obj = {
            pass: 3,
            user_id: parseInt(this.userId),
            difficulty_id: 0,
            difficulty_name: this.addDifficulty.toUpperCase(),
          };
          this.axios
            .post("/du/get_document_difficulty", obj)
            .then((response) => {
              if (response.status == 200 || response.status == 204) {
                let Alert = {
                  type: "success",
                  isShow: true,
                  message: response.data.body.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
                this.addCancel();
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              } else {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                let Alert = {
                  type: "error",
                  isShow: true,
                  message: response.data.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            })
            .catch((error) => {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: Utility.apiError(error),
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.errorMessage = error.message;
            });
        }
      }
    },
    //View Details in account
    viewDetails(item) {
      EncryptUtility.localStorageEncrypt("accountMastersDetails", JSON.stringify(item));
      this.$router.push({
        name: "documentMastersAccountList",
        params: {
          accountMastersDetails: btoa(JSON.stringify(item)),
        },
      });
    },
    //To add or remove Favourite issue
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
  },
};
